<div class="container-input">
  <input type="text" name="descricao" [(ngModel)]="descricao" placeholder="Descrição" #descricaoRef />
</div>
<ion-footer class="ion-no-padding">
  <ion-button fill="clear" color="primary" size="small" (click)="adicionarDescricao()">Confirmar</ion-button>
  <ion-button fill="clear" color="medium" size="small" (click)="closePopover()">Cancelar</ion-button>
</ion-footer>
